module.exports = {"data":{"site":{"siteMetadata":{"title":"Daub Creative :: Custom Websties and Mobile Apps"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 406
// module chunks = 142629428675168